import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { getAccountType } from "../../../store/auth/selectors";
import { checkPermission } from "../../utils/permissions";
import { PERMISSION_TYPES } from "../../utils/permissions";
import NavigationItem from "./NavigationItem";
import { navigationItems } from "../../../constants/navigationItems.js";

function SideBar() {
  const navigate = useNavigate();
  const location = useLocation();
  const accountType = useSelector(getAccountType);
  const checkUserPermission = (permissionType) =>
    checkPermission(accountType, permissionType);

  const getActiveItemFromPath = (pathname) => {
    const currentPath = pathname.slice(1);
    const matchingItem = navigationItems.find(
      (item) => item.path.toLowerCase() === currentPath
    );
    // Return null for global-events and pdf-upload to ensure no sidebar item is active
    if (
      currentPath.startsWith("global-events") ||
      currentPath === "pdf-upload"
    ) {
      return null;
    }
    return matchingItem ? matchingItem.label : navigationItems[0].label;
  };

  const [activeItem, setActiveItem] = useState(() =>
    getActiveItemFromPath(location.pathname)
  );

  useEffect(() => {
    setActiveItem(getActiveItemFromPath(location.pathname));
  }, [location.pathname]);

  const handleNavigation = (label, path) => {
    if (label === activeItem) return;
    setActiveItem(label);
    navigate(`/${path.toLowerCase()}`);
  };

  const getVisibleNavigationItems = () => {
    return navigationItems.filter((item) => {
      switch (item.path) {
        case "planner":
          return checkUserPermission(PERMISSION_TYPES.VIEW_EVENTS);
        case "invite-codes":
          return checkUserPermission(PERMISSION_TYPES.VIEW_INVITE_CODES);
        case "students":
          return checkUserPermission(PERMISSION_TYPES.VIEW_STUDENT_DETAILS);
        case "explore":
          return checkUserPermission(
            PERMISSION_TYPES.VIEW_EXPLORE_STUDENT_DETAILS
          );
        case "schools":
          return checkUserPermission(PERMISSION_TYPES.VIEW_SCHOOLS);
        case "teams":
          return checkUserPermission(PERMISSION_TYPES.VIEW_TEAMS);
        case "bulk-upload-jobs":
          return checkUserPermission(PERMISSION_TYPES.VIEW_BULK_UPLOAD_JOBS);
        default:
          return false;
      }
    });
  };

  const visibleNavigationItems = getVisibleNavigationItems();

  return (
    <nav
      style={{
        backgroundColor: "rgba(255, 255, 255, 1)",
        display: "flex",
        maxWidth: "250px",
        flexDirection: "column",
        alignItems: "center",
        padding: "10px 0",
        gap: "12px",
        position: "relative",
      }}
      role="navigation"
      aria-label="Main navigation"
    >
      {visibleNavigationItems.map((item, index) => (
        <NavigationItem
          key={index}
          icon={item.icon}
          label={item.label}
          path={item.path}
          isActive={activeItem !== null && item.label === activeItem}
          handleClick={() => handleNavigation(item.label, item.path)}
        />
      ))}
    </nav>
  );
}

export default SideBar;
